import React from "react";

const EmergencyContact = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g clipPath="url(#emergencycontracta)" fill="#73788B">
            <path className="u_fill" d="M32.986 23.004c-1.96 0-3.882-.306-5.706-.908-.894-.306-1.99-.026-2.536.534l-3.6 2.716c-4.172-2.228-6.74-4.796-8.94-8.938l2.638-3.504c.684-.684.93-1.684.636-2.62a18.198 18.198 0 0 1-.912-5.716A2.57 2.57 0 0 0 11.998 2H6.122a2.57 2.57 0 0 0-2.568 2.568C3.554 20.796 16.756 34 32.986 34a2.57 2.57 0 0 0 2.568-2.568v-5.86a2.57 2.57 0 0 0-2.568-2.568Z" fill={fill}/>
            <path className="u_fill" d="M31.432 23.004c-1.96 0-3.882-.306-5.706-.908-.892-.306-1.99-.026-2.536.534l-3.598 2.716c-4.172-2.226-6.744-4.796-8.94-8.938l2.636-3.504c.686-.684.93-1.684.636-2.62a18.198 18.198 0 0 1-.912-5.716A2.57 2.57 0 0 0 10.444 2H4.568A2.57 2.57 0 0 0 2 4.568C2 20.796 15.204 34 31.432 34A2.57 2.57 0 0 0 34 31.432v-5.86a2.57 2.57 0 0 0-2.568-2.568Z" fill={fill}/>
            <path className="u_fill"
                d="M25.142 3.8h-.2v5.142H19.8v2.118h5.142v5.14h2.116v-5.142H32.2V8.94h-5.142V3.8h-1.916Z"
                stroke="#73788B"
                strokeWidth={0.2} fill={fill}
            />
        </g>
        <defs>
            <clipPath id="emergencycontracta">
                <path className="u_fill" transform="translate(2 2)" d="M0 0h32v32H0z" fill={fill} />
            </clipPath>
        </defs>
    </svg>
);

export default EmergencyContact;
